const siteMetadata = {
  analytics: {
    googleAnalyticsId: "G-53YJ39VENV",
  },
};

export default siteMetadata;
